import React, { useEffect } from 'react'
import { Group, Stack } from '@mantine/core'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import { loadAllMasterTrades } from 'app/state/ducks/master-trades/thunks'
import { loadAllSubTrades } from 'app/state/ducks/sub-trades/thunks'
import { useDispatch, useSelector } from 'react-redux'
import TradeEntryFormLogic from './trade-entry-creation/trade-entry-form-logic'
import { TradeSearch } from './trade-search'
import { getMasterTrades } from 'app/state/ducks/master-trades/selectors'
import { MasterTradeParams } from 'app/models/master-trade-params'


interface props {
  tab: string
}

export function TradeCreateDrillPage({ tab }: props) {
  const dispatch = useDispatch()
  const masterTrades: MasterTradeParams[] = useSelector(getMasterTrades)

  useEffect(() => {
    dispatch(loadAllMasterTrades())
    dispatch(loadAllSubTrades())
  }, [])

  const tabs: { [key in props['tab']]: { route: string; label: string; active: boolean; pageRender: React.ReactNode; } } = {
    tradeEntryCreation: { route: '/tradeentry/create', label: 'CREATE TRADE', active: tab === 'tradeEntryCreation' ? true : false, pageRender: <TradeEntryFormLogic /> },
  }

  return (
    <Stack>
      <Group w="100%" position="apart" className='tabsGapsActivityWithTradeSearch'>
        <Group position="right">
          <SegmentControlUpdated tabs={tabs} />
        </Group>
        <Group noWrap className="searchActionsGroup" align="center">
          <TradeSearch
            data={masterTrades}
            placeholder="Trade Search"
          />
        </Group>
      </Group>
      {tabs[tab].pageRender}
    </Stack>
  )
}
